import type { ReactNode } from 'react';

import List from '@ingka/list';
import Text from '@ingka/text';
import { translate } from '@repo/phrase';

import styles from './styles.module.scss';

export interface TimeWindowAffectedServiceUpdateItem {
    key: string;
    name: string;
    proposedTimeWindowLabel: string;
}

interface Props {
    affectedServiceUpdateItems: TimeWindowAffectedServiceUpdateItem[];
    errorCode?: string | undefined;
    priceLabel: ReactNode;
    timeLabel: string;
    tspName?: string | undefined;
}

const renderPriceLabel = (priceLabel: ReactNode) => {
    if (typeof priceLabel === 'string') {
        return (
            <Text tagName="span" textStyle="Heading.XS">
                {priceLabel}
            </Text>
        );
    }

    return priceLabel;
};

export const TimeWindowListItemContent = ({
    affectedServiceUpdateItems,
    errorCode,
    priceLabel,
    timeLabel,
    tspName,
}: Props) => {
    return (
        <span className={String(styles.time_window_item_content)}>
            <span className={String(styles.time_window_item_header)}>
                <Text tagName="span" textStyle="Label.M" className={String(styles.time_window_title)}>
                    {timeLabel}
                </Text>
                <span className={styles.quantity_label}>{renderPriceLabel(priceLabel)}</span>
            </span>
            {tspName && (
                <Text tagName="span" textStyle="Body.M" className={String(styles.provider_name)}>
                    {tspName}
                </Text>
            )}
            {affectedServiceUpdateItems.length > 0 && (
                <div className={String(styles.affected_services)}>
                    <span className={String(styles.affected_services_header)}>
                        <Text tagName="span" textStyle="Body.M" className={String(styles.affected_services_title)}>
                            {translate('time_windows_dependency_info')}
                        </Text>
                    </span>
                    <List ordered className={String(styles.affected_services_list)}>
                        {affectedServiceUpdateItems.map((affectedServiceUpdateItem) => (
                            <li key={affectedServiceUpdateItem.key} className={String(styles.affected_service_item)}>
                                <Text
                                    tagName="span"
                                    textStyle="Body.M"
                                    className={String(styles.affected_service_name)}
                                >
                                    {affectedServiceUpdateItem.name}
                                </Text>
                                <Text
                                    tagName="span"
                                    textStyle="Body.M"
                                    className={String(styles.affected_service_time)}
                                >
                                    {`${translate('time_windows_dependency_new_date_time')} ${affectedServiceUpdateItem.proposedTimeWindowLabel}`}
                                </Text>
                            </li>
                        ))}
                    </List>
                </div>
            )}
            {errorCode && (
                <span className={String(styles.time_window_error)} role="note">
                    <Text tagName="span" textStyle="Body.M">
                        {translate(`align_proposal_error_${errorCode}`)}
                    </Text>
                </span>
            )}
        </span>
    );
};
